module.exports = __webpack_public_path__ + "img/sup_cardsetting_ewalletid5.f35c3395.jpg";